import PropTypes from 'prop-types';
import { Circle } from '@phosphor-icons/react';
import { useTranslation } from '@eti/providers';
import { css, cx, resetButtonStyle } from '@eti/styles';
import { breakpoints, Tooltip, vars } from '@etg/wings';
import TimelineWrapper from '../../../../common/TimelineWrapper';

const tooltipButton = css`
  border: 2px solid transparent;
  border-radius: 50%;
  display: inline-flex;

  &:focus-visible {
    border-color: ${vars.colors.focusRing};
    transition: all 0.2s ease;
  }

  @media (min-width: ${breakpoints._768}) {
    cursor: default;
  }
`;

const TimelineStop = ({
  borderStyleBefore,
  borderStyleAfter,
  'data-testid': dataTestId,
  tooltipText,
}) => {
  const { t } = useTranslation();

  return (
    <TimelineWrapper
      borderStyleAfter={borderStyleAfter}
      borderStyleBefore={borderStyleBefore}
      childSize={8}
      data-testid={dataTestId}
      key={dataTestId}
      wrapperSize={20}
    >
      {tooltipText ? (
        <Tooltip
          content={tooltipText}
          data-testid={`${dataTestId}-tooltip`}
          title={t('TripDetails.Stop.Label')}
        >
          <button
            className={cx(resetButtonStyle, tooltipButton)}
            data-testid={`${dataTestId}-tooltip-button`}
            type="button"
          >
            <Circle
              aria-label={t('TripDetails.Stop.Label')}
              color="#000"
              data-testid={`${dataTestId}-icon`}
              size={8}
              weight="fill"
            />
          </button>
        </Tooltip>
      ) : (
        <Circle
          aria-hidden="true"
          color="#000"
          data-testid={`${dataTestId}-icon`}
          size={8}
          weight="fill"
        />
      )}
    </TimelineWrapper>
  );
};

TimelineStop.propTypes = {
  borderStyleAfter: PropTypes.string,
  borderStyleBefore: PropTypes.string,
  'data-testid': PropTypes.string,
  tooltipText: PropTypes.string,
};

export default TimelineStop;
